/*
 * ceq-customer-cases.js
 * Reihenfolge der Gallery-Kacheln (.ceq-cc-gallery). Cache-immun, weil clientseitig.
 * Modi (data-order-mode): manual | random_load | random_daily | random_weekly.
 * Liquid rendert ALLE Cases; dieses Script ordnet sie um, CSS (:nth-child) zeigt nur die ersten N.
 * Seeded Shuffle: daily/weekly nutzen den Tag/Woche als Seed -> stabil im Intervall, alle Besucher gleich.
 */
(function () {
  // Deterministischer PRNG (mulberry32) für seeded Shuffle
  function mulberry32(a) {
    return function () {
      a |= 0; a = (a + 0x6d2b79f5) | 0;
      var t = Math.imul(a ^ (a >>> 15), 1 | a);
      t = (t + Math.imul(t ^ (t >>> 7), 61 | t)) ^ t;
      return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
    };
  }

  function shuffle(arr, rng) {
    for (var i = arr.length - 1; i > 0; i--) {
      var j = Math.floor(rng() * (i + 1));
      var tmp = arr[i]; arr[i] = arr[j]; arr[j] = tmp;
    }
    return arr;
  }

  var DAY = 86400000;
  function seedFor(mode) {
    if (mode === 'random_daily') return Math.floor(Date.now() / DAY);
    if (mode === 'random_weekly') return Math.floor(Date.now() / (DAY * 7));
    return Math.floor(Math.random() * 4294967296); // random_load
  }

  function order(gallery) {
    if (gallery.dataset.ccDone) return;
    gallery.dataset.ccDone = '1';

    var mode = gallery.getAttribute('data-order-mode') || 'manual';
    var grid = gallery.querySelector('.ceq-cc-gallery__grid');
    if (!grid) return;

    var tiles = Array.prototype.slice.call(grid.querySelectorAll('.ceq-cc-ovcard'));
    if (tiles.length < 2) return;

    if (mode === 'manual') {
      tiles.sort(function (a, b) {
        return (parseInt(a.dataset.sort || '0', 10)) - (parseInt(b.dataset.sort || '0', 10));
      });
    } else {
      shuffle(tiles, mulberry32(seedFor(mode)));
    }

    // Neue Reihenfolge in den DOM schreiben -> CSS :nth-child zeigt die ersten N
    tiles.forEach(function (t) { grid.appendChild(t); });
  }

  function init() {
    var galleries = document.querySelectorAll('.ceq-cc-gallery[data-order-mode]');
    Array.prototype.forEach.call(galleries, order);
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();

/*
 * Lightbox für die Detailseiten-Galerie ([data-cc-lightbox]).
 * Klick auf eine Kachel öffnet das grosse Bild (data-full); im Vollbild lässt sich
 * mit Pfeil-Buttons / Pfeiltasten zum nächsten und vorherigen Bild blättern (Wrap-around).
 * Klick auf Hintergrund/Schliessen oder Esc schliesst.
 */
(function () {
  function init() {
    var galleries = document.querySelectorAll('[data-cc-lightbox]');
    if (!galleries.length) return;

    var box, img, vid, prev, next, counter;
    var list = [];   // [{ src, alt, video }] — video = MP4-URL (leer bei Bildern)
    var idx = 0;

    function ensure(labels) {
      if (box) return;
      box = document.createElement('div');
      box.className = 'ceq-cc-lightbox';

      img = document.createElement('img');
      img.alt = '';

      // Video-Element (fuer Video-Kacheln): laedt erst beim Oeffnen (Click-to-play)
      vid = document.createElement('video');
      vid.controls = true;
      vid.setAttribute('playsinline', '');
      vid.preload = 'metadata';
      vid.hidden = true;

      prev = document.createElement('button');
      prev.className = 'ceq-cc-lightbox__nav ceq-cc-lightbox__nav--prev';
      prev.type = 'button';
      prev.setAttribute('aria-label', labels.prev);
      prev.innerHTML = '<svg viewBox="0 0 24 24" focusable="false" aria-hidden="true"><path d="M15 5l-7 7 7 7" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';

      next = document.createElement('button');
      next.className = 'ceq-cc-lightbox__nav ceq-cc-lightbox__nav--next';
      next.type = 'button';
      next.setAttribute('aria-label', labels.next);
      next.innerHTML = '<svg viewBox="0 0 24 24" focusable="false" aria-hidden="true"><path d="M9 5l7 7-7 7" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';

      counter = document.createElement('div');
      counter.className = 'ceq-cc-lightbox__counter';

      var close = document.createElement('button');
      close.className = 'ceq-cc-lightbox__close';
      close.type = 'button';
      close.setAttribute('aria-label', labels.close);
      close.innerHTML = '&times;';

      box.appendChild(img);
      box.appendChild(vid);
      box.appendChild(prev);
      box.appendChild(next);
      box.appendChild(counter);
      box.appendChild(close);
      document.body.appendChild(box);

      // Hintergrund-Klick schliesst; Klicks auf Bild/Navigation nicht
      box.addEventListener('click', hide);
      img.addEventListener('click', function (e) { e.stopPropagation(); });
      vid.addEventListener('click', function (e) { e.stopPropagation(); });
      close.addEventListener('click', function (e) { e.stopPropagation(); hide(); });
      prev.addEventListener('click', function (e) { e.stopPropagation(); step(-1); });
      next.addEventListener('click', function (e) { e.stopPropagation(); step(1); });

      document.addEventListener('keydown', function (e) {
        if (!box.classList.contains('is-open')) return;
        if (e.key === 'Escape') hide();
        else if (e.key === 'ArrowLeft') step(-1);
        else if (e.key === 'ArrowRight') step(1);
      });
    }

    function render() {
      var cur = list[idx];
      if (!cur) return;
      if (cur.video) {
        img.hidden = true;
        vid.hidden = false;
        if (cur.src) vid.poster = cur.src;
        if (vid.getAttribute('src') !== cur.video) vid.src = cur.video;
        var p = vid.play();
        if (p && p.catch) p.catch(function () {}); // Autoplay-Block ignorieren, Controls sind da
      } else {
        vid.pause();
        vid.hidden = true;
        img.hidden = false;
        img.src = cur.src;
        img.alt = cur.alt || '';
      }
      var many = list.length > 1;
      prev.hidden = !many;
      next.hidden = !many;
      counter.hidden = !many;
      if (many) counter.textContent = (idx + 1) + ' / ' + list.length;
    }

    function step(dir) {
      if (list.length < 2) return;
      idx = (idx + dir + list.length) % list.length; // Wrap-around
      render();
    }

    function open(items, start, labels) {
      ensure(labels);
      list = items;
      idx = start;
      render();
      box.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    }

    function hide() {
      if (!box) return;
      if (vid) vid.pause();
      box.classList.remove('is-open');
      document.body.style.overflow = '';
    }

    Array.prototype.forEach.call(galleries, function (g) {
      if (g.dataset.ccLbDone) return;
      g.dataset.ccLbDone = '1';
      var labels = {
        prev: g.getAttribute('data-lb-prev') || 'Previous image',
        next: g.getAttribute('data-lb-next') || 'Next image',
        close: g.getAttribute('data-lb-close') || 'Close'
      };
      g.addEventListener('click', function (e) {
        var item = e.target.closest('.ceq-cc-detail__g-item');
        if (!item || !g.contains(item)) return;
        var nodes = Array.prototype.slice.call(g.querySelectorAll('.ceq-cc-detail__g-item'));
        var items = nodes.map(function (n) {
          var im = n.querySelector('img');
          return { src: n.getAttribute('data-full'), alt: im ? im.alt : '', video: n.getAttribute('data-video') || '' };
        }).filter(function (it) { return it.src || it.video; });
        var start = nodes.indexOf(item);
        if (start < 0) start = 0;
        open(items, start, labels);
      });
    });
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();

/*
 * Kategorie-Filter der Übersichtsseite ([data-cc-filter]).
 * Chips filtern die Karten ([data-category]) clientseitig (cache-immun). Mehrfachauswahl;
 * Deep-Link ?kategorie=<handle>[,<handle>...]. "Alle" setzt zurück.
 */
(function () {
  function init() {
    var roots = document.querySelectorAll('[data-cc-filter]');
    Array.prototype.forEach.call(roots, function (root) {
      if (root.dataset.ccFilterDone) return;
      root.dataset.ccFilterDone = '1';

      var chipWrap = root.querySelector('.ceq-cc-overview__filters');
      var chips = Array.prototype.slice.call(root.querySelectorAll('.ceq-cc-chip'));
      var tiles = Array.prototype.slice.call(root.querySelectorAll('[data-category]'));
      var empty = root.querySelector('.ceq-cc-overview__empty');
      if (!chips.length || !tiles.length) return;

      // Chips nach sort_order ordnen ("Alle" = -1 zuerst)
      chips.sort(function (a, b) {
        return (parseInt(a.dataset.sort || '0', 10)) - (parseInt(b.dataset.sort || '0', 10));
      });
      if (chipWrap) chips.forEach(function (c) { chipWrap.appendChild(c); });

      // Mehrfachauswahl: Set der aktiven Kategorie-Handles. Leer = "Alle".
      var selected = {};
      function selectedKeys() { return Object.keys(selected); }

      function render(updateUrl) {
        var keys = selectedKeys();
        var hasSel = keys.length > 0;
        var shown = 0;
        tiles.forEach(function (t) {
          var match = !hasSel || selected[t.getAttribute('data-category')] === true;
          t.style.display = match ? '' : 'none';
          if (match) shown++;
        });
        chips.forEach(function (c) {
          var on = c.dataset.cat === 'all' ? !hasSel : selected[c.dataset.cat] === true;
          c.classList.toggle('is-active', on);
          c.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
        if (empty) empty.hidden = shown !== 0;
        if (updateUrl && window.history && window.history.replaceState) {
          var url = new URL(window.location.href);
          if (!hasSel) url.searchParams.delete('kategorie');
          else url.searchParams.set('kategorie', keys.join(','));
          window.history.replaceState({}, '', url.toString());
        }
      }

      chips.forEach(function (c) {
        c.addEventListener('click', function () {
          if (c.dataset.cat === 'all') {
            selected = {};
          } else if (selected[c.dataset.cat]) {
            delete selected[c.dataset.cat];
          } else {
            selected[c.dataset.cat] = true;
          }
          render(true);
        });
      });

      // Deep-Link beim Laden (kommagetrennt)
      var params = new URLSearchParams(window.location.search);
      var initial = params.get('kategorie');
      if (initial) {
        initial.split(',').forEach(function (h) {
          h = h.trim();
          if (h && chips.some(function (c) { return c.dataset.cat === h; })) selected[h] = true;
        });
      }
      render(false);
    });
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();

/*
 * Sortier-Dropdown der Übersichtsseite ([data-cc-sort]).
 * Ordnet die Karten im Grid clientseitig um (cache-immun) — läuft unabhängig vom
 * Kategorie-Filter (der nur display:none toggelt). Modi:
 *   empfohlen = is_featured zuerst, dann sort_order aufsteigend (kuratiert)
 *   jahr      = opening2 absteigend (neueste zuerst), Cases ohne Jahr ans Ende
 *   jahr_asc  = opening2 aufsteigend (älteste zuerst), Cases ohne Jahr ans Ende
 *   name      = Name A–Z (locale-aware, Intl.Collator)
 *   name_desc = Name Z–A
 * Stabiler Tiebreaker = ursprüngliche DOM-Reihenfolge (= Metaobjekt-Reihenfolge).
 */
(function () {
  function init() {
    var selects = document.querySelectorAll('[data-cc-sort]');
    Array.prototype.forEach.call(selects, function (select) {
      var grid = document.getElementById(select.getAttribute('data-cc-sort'));
      if (!grid) return;
      var tiles = Array.prototype.slice.call(grid.querySelectorAll('.ceq-cc-ovcard'));
      if (tiles.length < 2) return;

      var collator = new Intl.Collator('de', { sensitivity: 'base', numeric: true });
      function num(t, attr, fallback) {
        var v = parseInt(t.getAttribute(attr), 10);
        return isNaN(v) ? fallback : v;
      }
      function orig(a, b) { return tiles.indexOf(a) - tiles.indexOf(b); } // tiles bleibt in Original-Reihenfolge

      function apply(mode) {
        var sorted = tiles.slice();
        if (mode === 'name' || mode === 'name_desc') {
          var dir = mode === 'name_desc' ? -1 : 1;
          sorted.sort(function (a, b) {
            var c = collator.compare(a.getAttribute('data-name') || '', b.getAttribute('data-name') || '');
            return c !== 0 ? c * dir : orig(a, b);
          });
        } else if (mode === 'jahr' || mode === 'jahr_asc') {
          var ydir = mode === 'jahr_asc' ? -1 : 1; // jahr = absteigend (neueste), jahr_asc = aufsteigend (älteste)
          sorted.sort(function (a, b) {
            var ya = num(a, 'data-year', null), yb = num(b, 'data-year', null);
            if (ya === null && yb === null) return orig(a, b);
            if (ya === null) return 1;   // ohne Jahr immer ans Ende
            if (yb === null) return -1;
            return yb !== ya ? (yb - ya) * ydir : orig(a, b);
          });
        } else { // empfohlen
          sorted.sort(function (a, b) {
            var fa = a.getAttribute('data-featured') === 'true' ? 0 : 1;
            var fb = b.getAttribute('data-featured') === 'true' ? 0 : 1;
            if (fa !== fb) return fa - fb;
            var sa = num(a, 'data-order', 9999), sb = num(b, 'data-order', 9999);
            return sa !== sb ? sa - sb : orig(a, b);
          });
        }
        sorted.forEach(function (t) { grid.appendChild(t); });
      }

      select.addEventListener('change', function () { apply(select.value); });
      apply(select.value); // Startwert (= "empfohlen") direkt anwenden
    });
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();

/*
 * "Alle anzeigen"-Toggle der Equipment-Section ([data-equip-toggle]).
 * Klappt lange Produktlisten auf Mobile auf (CSS kappt die Hoehe per is-collapsible).
 * Klick blendet die volle Liste ein und versteckt den Button (nur Mobile relevant).
 */
(function () {
  function init() {
    var btns = document.querySelectorAll('[data-equip-toggle]');
    Array.prototype.forEach.call(btns, function (btn) {
      btn.addEventListener('click', function () {
        var list = btn.previousElementSibling;
        if (!list || !list.hasAttribute('data-equip-list')) return;
        list.classList.add('is-expanded');
        btn.setAttribute('aria-expanded', 'true');
      });
    });
  }
  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
